import { isAdminConsentRequiredError, OfficeSingleSignOnError } from '@utils-global';

export const handleSSOErrors = (
  error: OfficeSingleSignOnError,
  showToast: (translationKey: string, options?: unknown) => void,
) => {
  // Check for admin consent required error (AADSTS65001)
  if (isAdminConsentRequiredError(error)) {
    showToast('errors.adminConsentRequired');
    return null;
  }

  switch (error.code) {
    case 13001:
      // No one is signed into Office. If the add-in cannot be effectively used when no one
      // is logged into Office, then the first call of getAccessToken should pass the
      // `allowSignInPrompt: true` option. Since this sample does that, you should not see
      // this error.
      showToast('errors.sso.13001');
      break;
    case 13002:
      // The user aborted the consent prompt. If the add-in cannot be effectively used when consent
      // has not been granted, then the first call of getAccessToken should pass the `allowConsentPrompt: true` option.
      showToast('errors.sso.13002');
      break;
    case 13006:
      // Only seen in Office on the web.
      showToast('errors.sso.13006');
      break;
    case 13008:
      // Only seen in Office on the web.
      showToast('errors.sso.13008');
      break;
    case 13010:
      // Only seen in Office on the web.
      showToast('errors.sso.13010');
      break;
    case 13013:
      // API has been throttled. This happens when too many authentication requests are made in a short time.
      // The retry logic in loginSSO should handle this, but if it persists, show a user-friendly message.
      showToast('errors.sso.throttled');
      break;
    default:
      // For all other errors, including 13000, 13003, 13005, 13007, 13012, and 50001
      // Means that SSO doesn't work on this platform
      break;
  }
  // Return null for errors that show a message to the user.
  return null;
};
